/** Origine d'une ligne de besoin en denrées (issue #3622) — miroir de OrigineBesoinDenreeEnum côté back. */
export enum OrigineBesoinDenreeEnum {
  PRESTATION = 'PRESTATION',
  PRODUIT_COMPLEMENTAIRE = 'PRODUIT_COMPLEMENTAIRE',
  PRESTATION_AND_PRODUIT_COMPLEMENTAIRE = 'PRESTATION_AND_PRODUIT_COMPLEMENTAIRE'
}

export const ORIGINE_BESOIN_DENREE_LABELS: Record<OrigineBesoinDenreeEnum, string> = {
  [OrigineBesoinDenreeEnum.PRESTATION]:                           'Prestation',
  [OrigineBesoinDenreeEnum.PRODUIT_COMPLEMENTAIRE]:                'Produit complémentaire',
  [OrigineBesoinDenreeEnum.PRESTATION_AND_PRODUIT_COMPLEMENTAIRE]: 'Prestation + produit complémentaire',
};
